let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '制卡时间',
        props: 'madeTime',
        minWidth: 200,
    },
    {
        label: '制卡人',
        props: 'madeBy',
        minWidth: 300,
    },
    {
        label: '兑换码',
        props: 'exchangeCode',
        minWidth: 200,
    },
    {
        label: '使用状态',
        props: 'cardStatusName',
        minWidth: 200,
    },
    {
        label: '使用时间',
        props: 'useredTime',
        minWidth: 200,
    },
    {
        label: '使用账号',
        props: 'useredBy',
        minWidth: 120,
    },
    {
        label: '度电',
        props: 'cardElectric',
        minWidth: 200,
    },
    {
        label: '制卡原因',
        props: 'madeReason',
        minWidth: 180,
    },
];

// // 面包屑
pageConfig.listBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'title',
    name: '财务管理'
},
{
    type: 'title',
    name: '制卡管理'
}];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: false,
    showIndex: true,
    herderStyle:{background:'#FAFAFA',color: '#8F9BB3',fontSize: '14px',fontFamily:'PingFangSC-Medium, PingFang SC'}
};

// 列表-表格属性
pageConfig.detailTableConfig = {
    showSelection: true,
    showIndex: true,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}
// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'id',
    editRouter: 'financeReviewDetail',
};

// 路由
pageConfig.listRouter = 'cardList';

pageConfig.detailRouter = 'financeReviewDetail';

// 详情的面包屑
pageConfig.detailBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'title',
    name: '财务管理'
},
{
    type: 'router',
    name: '财务审核',
    router: 'cardList'
},
{
    type: 'title',
    name: '审核详情'
}];

pageConfig.formRules = {
    cardMoney: [{
        required: true,
        message: '请选择制卡金额',
        trigger: 'change'
    }],
    madeReason: [{
        required: true,
        message: '请填写制卡原因',
        trigger: 'blur'
    }],
};



export default pageConfig;